let store = null

export const setGlobalStore = (inStore) => {
  store = inStore
}

export const getGlobalStore = () => {
  return store
}

export const dispatch = (args) => {
  store.dispatch.apply(null, args)
}

export default store

